import React, { useState, useEffect } from "react";

import Table from "../common/Table";
import Option from "../common/RowOption";
import calc from "../../utils/calculation";

import lbl from "../../data/Labels.json";

const FinancePayableList = ({ activeYear, data, setChart }) => {
  const payablesColumns = [
    { path: "id", label: "شماره" },
    {
      path: "month",
      label: "ماه",
      content: (e) => (
        <a href="#" onClick={() => setChart(e)}>
          {e.month}
        </a>
      ),
    },
    { path: "year", label: "سال" },
    { path: "present_count", label: "حاضر" },
    { path: "absent_count", label: "غیر حاضر" },
    { path: "holiday_count", label: "رخصت" },
    { path: "salary_per_month", label: "معاش" },
    { path: "absent_cut", label: "کسر غیابت" },
    { path: "salary_tax", label: "مالیه" },
    { path: "amount", label: "قابل پرداخت" },
    { path: "option" },
  ];

  const [rows, getRows] = useState([]);

  useEffect(() => {
    if (data.data) {
      const filteredData = data?.data[0]?.payables.filter(
        (p) => p.half_year_id === (activeYear.half_year_id || activeYear)
      );
      getRows(filteredData);
    }
  }, [activeYear]);

  return (
    <div className="table-card">
      <p className="table-title">{lbl.Payables}</p>
      <Table
        data={rows}
        columns={payablesColumns}
        total={rows && calc.getTotal(rows, "amount")}
      />
    </div>
  );
};

export default FinancePayableList;
